module.exports = __webpack_public_path__ + "media/images/logo-unimed-0c751276c4bb7717746e47401045137a.png";